export const themeTokens = {
  palette: {
    primary: {
      main: "#FFC02A",
      contrastText: "#1E1E1E",
    },
    background: {
      black: "#1E1E1E",
      secondary: "#F8F8F8",
      postFoot: "#ECECEC",
      authBg: "rgba(255,255,255,0.88)",
    },
    text: {
      white: "#FFFFFF",
      secondary: "#C8C8C8",
      darkSecondary: "#4B4B4B",
    },
  },
  typography: {
    fontFamily: "SofiaProMedium",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: "bold",
          borderRadius: "10px",
        },
      },
    },
  },
};
